module.exports = __webpack_public_path__ + "static/media/breakdown.89593850.svg";